import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import type { ComposeComponentImageAndAdjacentTextFragment } from '../../../.graphql/generated-types'
import { ContentfulRichText } from '../../components/ContentfulRichText'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'

export interface ComposeComponentImageAndAdjacentTextProps {
  data: ComposeComponentImageAndAdjacentTextFragment
}

export function ComposeComponentImageAndAdjacentText({
  data,
}: ComposeComponentImageAndAdjacentTextProps) {
  const imageUrl = data.image?.url
  const imageWidth = data.image?.width
  const imageHeight = data.image?.height
  const imageTitle = data.image?.title ?? 'Image supporting adjacent text'
  return (
    <div className="md:flex md:space-x-4">
      {imageUrl && imageWidth && imageHeight && (
        <div className="flex shrink-0 justify-center md:block">
          <ContentfulImageWithPlaceholder
            alt={imageTitle}
            src={imageUrl}
            width={imageWidth}
            height={imageHeight}
          />
        </div>
      )}
      <div>
        <ContentfulRichText
          document={data.text?.json as Document}
          entries={data.text?.links.entries}
          className="my-6 space-y-6 text-lg"
        />
      </div>
    </div>
  )
}
